<template>
  <Form style="line-height:32px"
        ref="formdata"
        :model="formdata"
        :label-width="120"
        inline>
    <FormItem :label="$t('erp.b2c.search_errorcode',{defaultValue:'异常类型'})"
              style="width:90%"
              :rules="required"
              prop="errortype">
      <Select v-model="formdata.errortype"
              filterable>
        <Option v-for="item in alltypes"
                :value="item.value"
                :key="item.value">{{item.title}}</Option>
      </Select>
    </FormItem>
    <FormItem :label="$t('erp.b2c.exception_content',{defaultValue:'异常内容'})"
              style="width:90%"
              :rules="required"
              prop="errorremark">
      <Input v-model="formdata.errorremark"
             :rows="3"
             type="textarea" />
    </FormItem>
    <footer class="text-right">
      <Button type="primary"
              @click="submit">{{$t('global.common.update_submit',{defaultValue:'提交'})}}</Button>
      <Button class="margin-left-10"
              @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
    </footer>
    <Spin size="large"
          fix
          v-if="loading"></Spin>
  </Form>
</template>
<script>
import {
  HttpSubmitError
} from '@/service/boss/b2corder'
export default {
  props: ['activeids'],
  data () {
    return {
      loading: false,

      alltypes: [
        { value: 0, title: this.$t('erp.b2c.errorcode_unexception', { defaultValue: '无异常' }) },
        { value: 100, title: this.$t('erp.b2c.errorcode_systemException', { defaultValue: '系统异常' }) },
        { value: 1000, title: this.$t('erp.b2c.errorcode_produceException', { defaultValue: '商品无法关联' }) },
        { value: 2000, title: this.$t('erp.b2c.errorcode_addressException', { defaultValue: '订单地址异常' }) },
        { value: 3000, title: this.$t('erp.b2c.errorcode_updateException', { defaultValue: '订单更新异常' }) },
        { value: 4000, title: this.$t('erp.b2c.errorcode_pickingException', { defaultValue: '订单配货异常' }) },
        { value: 5000, title: this.$t('erp.b2c.errorcode_cancelException', { defaultValue: '订单取消异常' }) },
        { value: 6000, title: this.$t('erp.b2c.errorcode_trackingException', { defaultValue: 'Tracking异常' }) },
        { value: 7000, title: this.$t('erp.b2c.errorcode_costException', { defaultValue: '订单成本异常' }) },
        { value: 4500, title: this.$t('erp.b2c.errorcode_carrierException', { defaultValue: '订单发运方式异常' }) },
        { value: 4600, title: this.$t('erp.b2c.errorcode_uploadException', { defaultValue: '上传异常' }) },
        { value: 8000, title: this.$t('erp.b2c.errorcode_insufficientInventoryException', { defaultValue: '库存不足异常' }) },
        { value: 8001, title: this.$t('erp.b2c.errorcode_deliverOrderCancelException', { defaultValue: '发货单取消异常' }) },
      ],
      formdata: {
        errortype: "",
        errorremark: '',
      },
      required: [{
        required: true,
        message: this.$t("global.common.fill_requiredd", { defaultValue: '该信息不能为空,请填写' })
      }],
    }
  },
  methods: {
    cancel () {
      this.$emit('on-close')
    },
    async submit () {
      let bool = await this.$refs['formdata'].validate();
      if (!bool) return;
      this.loading = true;
      HttpSubmitError({
        orderIds: this.activeids,
        errorCode: this.formdata.errortype,
        errorMessage: this.formdata.errorremark
      }).then(res => {
        this.$Message.success(res.message);
        this.cancel();
        this.$emit('on-update');
      }, err => {
        this.$VMessage.error({
          content: err.message,
          duration: 30,
          closable: true
        });
      }).finally(() => {
        this.loading = false;
      })
    },
  }
}
</script>
